import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input } from 'components'
import { Formik } from 'formik'
import Mail from 'globals/models/Mail'
import popupSuccess from 'globals/popupSuccess'
import { displayErrors } from 'globals/graphql'
import { useMutation } from '@apollo/client'
import {
  MailActionVariables,
  UpdateMailResult,
  UPDATE_TRACKING_NUMBER
} from 'pages/ClientDetails/components/MailDetails/mutations'
import * as Yup from 'yup'
import { TFunction } from 'i18next'

interface IProps {
  mail: Mail,
  callback: (ids: React.Key[]) => void,
}

interface trackingNumberForm {
  trackingNumber?: string,
}

const MailQuickActionForward = (props: IProps) => {
  const { t } = useTranslation()
  const initialValues: trackingNumberForm = {}
  const [saved, setSaved] = useState(false)
  const [trackingNumber, setTrackingNumber] = useState('')

  const validation = (t: TFunction): Yup.SchemaOf<any> => Yup.object({
    trackingNumber: Yup.string().required(t('global.error.required', { field: t('mails.tracking-number') }))
  })

  const [updateMail] = useMutation<UpdateMailResult, MailActionVariables>(UPDATE_TRACKING_NUMBER, displayErrors)

  const onSubmit = (data: any) => {
    updateMail({ variables: { userMailId: props.mail.id, trackingNumber: data.trackingNumber } })
        .then(() => {
          popupSuccess('Numéro de suivi ajouté')
          props.callback?.([props.mail.id])
          setSaved(true)
          setTrackingNumber(data.trackingNumber)
        })
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validation(t)}
    >
      <Form>
        {!saved &&
          <Input
            name="trackingNumber"
            placeholder={t('mails.tracking-number')}
            defaultValue={''}
            validateEnabledRegexp={/[a-zA-Z0-9]{3,}/}
            validateText="Réexpédier"
            noBottomPadding={true}
            bottomPadding={0}
            required
          />
        }
        {saved && <>{trackingNumber}</>}
      </Form>
    </Formik>
  )
}

export default MailQuickActionForward
